export interface Company {
  id: string;
  slug: string;
  displayName: string;
  legalName: string;
  oib: string;
  city: string;
  status: string;
  employeeLimit: number;
  hostname: string | null;
  logoUrl: string | null;
  address: string;
  postalCode: string;
  contactName: string | null;
  contactEmail: string | null;
  contactPhone: string | null;
  primaryColor: string;
  secondaryColor: string;
  trialEndsAt: string | null;
  licenseValidUntil: string | null;
  enabledModules: string[];
  createdAt: string;
}

export interface Module {
  id: string;
  key: string;
  name: string;
  description: string | null;
  phase: number;
  isCore: boolean;
  dependencies: string[];
  status: 'ACTIVE' | 'COMING_SOON' | 'RETIRED';
  enabledCompanyCount: number;
}

export interface CompanyDetail {
  id: string;
  slug: string;
  legalName: string;
  displayName: string;
  oib: string;
  address: string;
  postalCode: string;
  city: string;
  countryCode: string;
  contactName: string | null;
  contactEmail: string | null;
  contactPhone: string | null;
  logoUrl: string | null;
  primaryColor: string;
  secondaryColor: string;
  timezone: string;
  locale: string;
  status: string;
  employeeLimit: number;
  trialEndsAt: string | null;
  licenseValidUntil: string | null;
  provisionedAt: string | null;
  createdAt: string;
  hostname: string | null;
  planName: string;
  subscriptionStatus: string | null;
  enabledModules: string[];
  database: {
    name: string;
    schemaVersion: string | null;
    health: string | null;
    checkedAt: string | null;
  } | null;
  provisioning: {
    status: string | null;
    step: string | null;
    error: string | null;
  };
}

export interface ProvisionResult {
  companyId: string;
  hostname: string;
  enabledModules: string[];
  initialAdmin: {
    email: string;
    activationToken: string;
  };
}

export function statusLabel(status: string): string {
  const labels: Record<string, string> = {
    ACTIVE: 'Aktivna',
    PROVISIONING: 'Postavljanje',
    SUSPENDED: 'Obustavljena',
    FAILED: 'Pogreška',
    DRAFT: 'Nacrt',
    CLOSED: 'Zatvorena',
    HEALTHY: 'U redu',
    UNHEALTHY: 'Nedostupna',
    UNKNOWN: 'Nije provjereno',
    SUCCEEDED: 'Uspješno'
  };
  return labels[status] ?? status;
}
